export const TextInputWidgetId = 'TextInputWidget';

export enum TextInputWidgetAttributes {
  LABEL = 'label',
  PLACEHOLDER = 'placeholder',
  VALUE = 'value',
  QUERY_NAME = 'queryName',
  TYPE = 'type',
  HELPER_TEXT = 'helperText',
  DISABLED = 'disabled',
  AUTO_COMPLETE = 'autoComplete',
  READ_ONLY = 'readOnly',
  MULTILINE = 'multiline',
  REGEXP = 'regexp',
}

export enum TextInputWidgetTypes {
  TEXT = 'text',
  PASSWORD = 'password',
  NUMBER = 'number',
  HIDDEN = 'hidden',
  EMAIL = 'email',
  TEL = 'tel',
}

export enum TextInputAutocompleteTypes {
  NONE = '',
  NAME = 'name',
  GIVEN_NAME = 'given-name',
  FAMILY_NAME = 'family-name',
  EMAIL = 'email',
  TEL = 'tel',
  STREET_ADDRESS = 'street-address',
  POSTAL_CODE = 'postal-code',
  ADDRESS_LEVEL2 = 'address-level2',
  ORGANIZATION = 'organization',
}
